#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"
#import "~/graphql/fragments/Components/ContentBlocks.graphql"
#import "~/graphql/fragments/CoreEntryFields.graphql"
#import "~/graphql/fragments/Entry/Default.graphql"
#import "~/graphql/fragments/Entry/Detail.graphql"
#import "~/graphql/fragments/Entry/Overview.graphql"
#import "~/graphql/fragments/Entry/CtaCards.graphql"
#import "#layers/seo/graphql/fragments/Seomatic.graphql"

query Entry($uri: [String], $site: [String] = "nl", $section: [String]) {
    entry(uri: $uri, site: $site, section: $section) {
        ... CoreEntryFields
        ... SeomaticFields

        ... Default
        ... Detail
        ... Overview
        ... CtaCards

        sectionHandle

        parent {
            title
            uri
        }
    }
}
